import { render, staticRenderFns } from "./AvailableUsersCounter.vue?vue&type=template&id=496f38ff&scoped=true"
import script from "./AvailableUsersCounter.vue?vue&type=script&lang=ts"
export * from "./AvailableUsersCounter.vue?vue&type=script&lang=ts"
import style0 from "./AvailableUsersCounter.vue?vue&type=style&index=0&id=496f38ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496f38ff",
  null
  
)

export default component.exports